<template>
    <el-card>
        <div slot="header" class="clearfix">
            <el-row type="flex" align="middle">
                <el-col class="card-heading">Test Video</el-col>
                <el-col>
                    <el-button class="test-button" @click="toggleVideo($event)"
                        >Play</el-button
                    >
                </el-col>
            </el-row>
        </div>
        <el-row
            type="flex"
            align="middle"
            justify="space-between"
            v-if="videoDevices.length"
        >
            <el-col class="result-heading">
                <el-select
                    v-model="selectedDevice"
                    placeholder="Select video device"
                >
                    <el-option
                        v-for="device in videoDevices"
                        :key="device.deviceId"
                        :value="device.deviceId"
                        :label="device.label"
                    >
                    </el-option>
                </el-select>
            </el-col>
            <el-col class="video-height" :offset="1" :span="10">
                <video
                    autoplay
                    id="showVideo"
                    poster="../../../public/favicon-large.png"
                ></video>
            </el-col>
        </el-row>
        <status-content v-if="videoDevices.length == 0" :content="error" />
    </el-card>
</template>

<script>
import { mapState } from 'vuex';
import StatusContent from './StatusContent.vue';
const PLAY_TEXT = 'Play';
const STOP_TEXT = 'Stop';

export default {
    name: 'VideoCheck',
    components: {
        StatusContent,
    },
    data: function() {
        return {
            isPlaying: false,
            videoMedia: null,
        };
    },
    watch: {},
    computed: {
        ...mapState({
            videoDevices: (state) => state.devices.videoDevices,
            error: (state) => state.devices.videoError,
        }),
        selectedDevice: {
            get() {
                return this.$store.state.devices.selectedVideoDevice;
            },
            set(value) {
                this.$store.commit('devices/setSelectedVideoDevice', value);
            },
        },
    },
    mounted: async function() {},
    methods: {
        async toggleVideo(event) {
            if (this.videoMedia && this.videoMedia.active) {
                this.videoMedia.getVideoTracks().forEach((track) => {
                    track.stop();
                });
                const video = document.querySelector('#showVideo');
                video.srcObject = null;
                event.target.innerText = PLAY_TEXT;
            } else {
                try {
                    this.$store.commit('devices/setVideoDevices');
                    this.videoMedia = await navigator.mediaDevices.getUserMedia(
                        {
                            video: true,
                            deviceId: {
                                exact: this.selectedDevice,
                            },
                        }
                    )
                    setTimeout(() => {
                        const video = document.querySelector('#showVideo');
                        video.srcObject = this.videoMedia;
                    }, 10);
                    event.target.innerText = STOP_TEXT;
                } catch (error) {
                    console.log(error);
                }
            }
        },
        handleDevicesAndError() {
            this.$store.commit('devices/setVideoDevices');
        },
    },
};
</script>

<style scoped>
.clearfix:before,
.clearfix:after {
    display: table;
    content: '';
}
.clearfix:after {
    clear: both;
}
.video-height {
    height: 100px;
}
.width-100 {
    width: 100%;
}

.test-button {
    float: right;
}
div.result-heading,
div.card-heading {
    text-align: left;
}
video {
    height: 100%;
    width: 100%;
}
.el-select {
    width: 100%;
}
.el-icon {
    font-size: 30px;
}
.el-icon-error {
    color: #d32f2f;
}
.el-icon-warning {
    color: rgb(255, 102, 0);
}
</style>
